export const CREATE_PRODUCER				 = 'CREATE_PRODUCER'
export const CREATE_PRODUCER_SUCCESS = 'CREATE_PRODUCER_SUCCESS'
export const CREATE_PRODUCER_FAIL	   = 'CREATE_PRODUCER_FAIL'